import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  field: {
    input: {
      '&:user-invalid': {
        // borderColor: theme.palette.error.main
        color: theme.palette.error.main
      }
    }
  }
}));

export default useStyles;